// services import
import { AudioManager } from './audio-manager';
import { AudioLibraryService } from './audio-library.service';
import { DeliveryPeriodService } from './delivery-period.service';
import { PackingListService } from './packing-list.service';

export const services: any[] = [
  // services export
  AudioManager,
  AudioLibraryService,
  DeliveryPeriodService,
  PackingListService,
];
